import React from "react";
import { useParams } from "react-router-dom";
import ChipStatus from "./ChipStatus.tsx";
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import EmptyImage from "../../assets/img/ic_content.svg";

const ApplicationListChangePosition = ({ applications, size = "lg" }) => {
  const { curp } = useParams();
  const { user } = useSelector((state: RootState) => state.auth);

  const filteredApplications = applications?.positionChanges?.filter(
    (application) => application.isApproved
  );

  return (
    <div className="col-xl-8" id="bsSpyContent">
      <div id="Aplications" className="mb-4 pb-3">
        {size === "lg" && (
          <React.Fragment>
            <h4 className="d-flex align-items-center mb-2">
              <i className="fa-solid fa-briefcase me-2 text-body-secondary" />
              Aplicaciones
            </h4>
            <p className="text-muted">
              Aquí puedes encontrar todas las postulaciones que se han realizado
              con la CURP {curp}.
            </p>
          </React.Fragment>
        )}
        <div className="row g-3">
          {filteredApplications?.length > 0 &&
            filteredApplications.map((application, index) => (
              <div className="col-12" key={index}>
                <div className="card shadow-sm border h-100 rounded-3 overflow-hidden">
                  <div className="card-body position-relative pt-3 pb-3 ps-4 pe-4">
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                      <div>
                        <h6 className="card-title mb-1 fw-bold text-dark fs-6">
                          <i className="fa-solid fa-arrow-right me-1 text-muted" />
                          Nueva posición: {application.newPosition?.name}
                        </h6>
                        <p className="card-text text-muted small mb-0">
                          Posición anterior: {application.oldPosition?.name}
                        </p>
                      </div>
                      <div className="text-end">
                        <ChipStatus
                          status={
                            application.isApproved
                              ? "Cambio de posición"
                              : "Pendiente"
                          }
                        />
                        {application.approvalDate && (
                          <p className="text-muted small mt-2 mb-0">
                            Aprobado:{" "}
                            {format(
                              parseISO(application.approvalDate),
                              "dd 'de' MMMM yyyy",
                              { locale: es }
                            )}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {(!filteredApplications || filteredApplications.length === 0) && (
          <div className="card border-0 shadow-sm rounded-3">
            <div className="card-body py-5 text-center">
              <img src={EmptyImage} alt="" className="img-fluid mb-3" style={{ maxWidth: "200px" }} />
              <h5 className="text-secondary mb-0">
                No existen registros aún
              </h5>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationListChangePosition;
